<template>
 	 <Radio v-model="data" :disabled="disabled" @on-change="$emit('on-change',value)" :border="border" :size="size"><slot></slot></Radio>
</template>

<script>
 
export default {
  components: {
  },
  props: ["value","lable","disabled","size","border"],
  data () {
      return {
    	  data : false
      }
  },
  mounted: function () {
	  if(this.value){
		  this.data = this.value=== this.lable;
	  }
  },
  methods: {
	  valueChange : function(){
		  
	  }
	  
  },
  watch : {
	  value : function(){
		  this.data = this.value=== this.lable;
	  },
	  data : function(){
		  if(this.data===true){
			  this.$emit("input", this.lable);
		  }
	  }
  }
}
</script>
<style>
 
</style>
